<template>
  <div>
    <div>
      <span
        :class="{
          // completed: task.status.id === 1,
          // canceled: task.status.id === 1,
        }"
        :title="type"
        >{{ type | truncate(8) }}</span
      >
    </div>
    <!--    :style="setSize()"-->

    <!--    <div-->
    <!--      v-if="transferred"-->
    <!--      type="button"-->
    <!--      class="transferIndicatorDot"-->
    <!--      title="This task is also transferred"-->
    <!--    ></div>-->
  </div>
</template>

<script>
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";
import { mapGetters, mapState } from "vuex";

export default {
  name: "TaskStatusType",
  props: {
    task: {
      type: Object,
      required: true
    },
    selectedTab: {
      type: String
    }
  },
  computed: {
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapState("user", ["auth"]),
    ...mapState("tasks", ["taskDictionaries"])
  },
  data() {
    return {
      // transferred: false,
      type: ""
    };
  },

  created() {
    this.setTaskType();
  },

  methods: {
    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });
      return originalCreator;
    },
    setTaskType() {
      let myType;
      let ifIHaveRequestedCheckFromCreator = this.task.task_check.some(
        user =>
          user.requested_check === this.auth.user.id &&
          user.is_checking === this.getOriginalCreator()
      );
      if (this.task.taskSubStatus.length) {
        const subStat = this.task.taskSubStatus.find(
          user => user.user_id === this.auth.user.id
        );
        // const subStat = this.task.taskSubStatus.find(user=> user.user_id === 45)
        if (subStat && subStat.task_sub_status_type) {
          if (
            subStat.task_sub_status_type.id === 6 &&
            this.task.task_check.length > 1 &&
            !ifIHaveRequestedCheckFromCreator
          ) {
            this.type = subStat.task_sub_status_type.title + "+";
          } else if (
            subStat.task_sub_status_type.id === 40 &&
            this.getOriginalCreator() !== this.auth.user.id
          ) {
            this.type = subStat.task_sub_status_type.title + "+";
          }
          // else if (subStat.task_sub_status_type.id === 43 || subStat.task_sub_status_type.id === 39) {
          //   this.type = subStat.task_sub_status_type.title.substring(0, 4);
          // }
          else {
            this.type = subStat.task_sub_status_type.title;
          }
          // this.type = subStat.task_sub_status_type.title
        }
      }

      // let haveSubStatus = this.task.taskSubStatus.some(user => {
      //   if (user.user_id === this.auth.user.id) {
      //     myType = user;
      //
      //     return true;
      //   } else {
      //     return false;
      //   }
      // });
      // if (haveSubStatus) {
      //   // this.type = myType.task_sub_status_type.type;
      //   this.type = myType.task_sub_status_type.title;
      // } else {
      //   this.type = this.selectedTab;
      // }
    },
    setSize() {
      if (this.task.user_status.status_type.id === 11) {
        return "font-size: 11px;";
      }
    }
    // checkOwnership() {
    //   let arr = [];
    //   for (let i = 0; i < this.task.task_assignment.length; i++) {
    //     arr.push(this.task.task_assignment[i].assigned_by.id);
    //   }
    //   let creators = [...new Set(arr)];
    //
    //   return creators.includes(this.auth.user.id);
    // },
    // checkPermissions(user, permitted) {
    //   return permitted.some(role => role === user.user.role);
    // },
    // async updateDueDate() {
    //   try {
    //     this.$store.commit("clients/setLoading", true);
    //     const addNewClientRequest = apiClientasktCreator(
    //       `tasks/update/due/${this.task.id}`
    //     );
    //     await addNewClientRequest.put("", {
    //       due_date: moment().add("hours", "25")
    //     });
    //     //  this.$emit("updated");
    //     this.$store.commit("tasks/setFetchTasks", { flag: true });
    //     this.$store.commit("main/setShowVikiMsg", {
    //       show: true,
    //       msg: "Task priority updated successfully",
    //       type: "DONE",
    //       op: { type: "SYSTEM" }
    //     });
    //     this.$store.commit("clients/setLoading", false);
    //   } catch (e) {
    //     this.$store.commit("main/setShowVikiMsg", {
    //       show: true,
    //       msg:
    //         "Error task priority update " +
    //         " " +
    //         " Error Status: " +
    //         e.response.status,
    //       type: "ERROR",
    //       op: { type: "SYSTEM" }
    //     });
    //     this.$store.commit("clients/setLoading", false);
    //   }
    // },
    // async updateTaskStatus(statusId) {
    //   try {
    //     this.$store.commit("clients/setLoading", true);
    //     const addNewClientRequest = apiClientCreator(
    //       `tasks/update/status/${this.task.id}`
    //     );
    //     await addNewClientRequest.put("", { status_id: statusId });
    //     //   this.$emit("updated");
    //     this.$store.commit("tasks/setFetchTasks", { flag: true });
    //     this.$store.commit("main/setShowVikiMsg", {
    //       show: true,
    //       msg: "Task status updated successfully",
    //       type: "DONE",
    //       op: { type: "SYSTEM" }
    //     });
    //     this.$store.commit("clients/setLoading", false);
    //   } catch (e) {
    //     this.$store.commit("main/setShowVikiMsg", {
    //       show: true,
    //       msg:
    //         "Error task status update " +
    //         " " +
    //         " Error Status: " +
    //         e.response.status,
    //       type: "ERROR",
    //       op: { type: "SYSTEM" }
    //     });
    //     this.$store.commit("clients/setLoading", false);
    //   }
    // }
  }
};
</script>

<style scoped>
.completed {
  background-color: #1565c0;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}
.created {
  background-color: #2e7d32;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}
.requested {
  background-color: #fdd835;
  color: black;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}

.progress {
  background-color: #7b1fa2;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}
.repeated {
  background-color: #7b1fa2;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}
.canceled {
  background-color: black;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}
.missed {
  background-color: red;
  color: white;
  padding-left: 3px;
  padding-right: 3px;
  padding-bottom: 2px;
  border-radius: 3px;
  font-size: 10pt;
  cursor: pointer;
}
.dropdown-menu {
  padding: 5px;
  height: auto;
  width: 100px !important;
  max-height: 200px;
  overflow-x: hidden;
}
.assignment-dropdown-menu {
  position: absolute;
  left: -5px;
  border: solid 1px #90a4ae;
  border-radius: 0;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.assignment-dropdown-menu ul {
  list-style: none;
  padding-left: 0;
}

.assignment-dropdown-menu li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
  cursor: pointer;
}

.assignment-dropdown-menu li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.assignment-dropdown-menu .item-text {
  vertical-align: middle;
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
}
.assignment-dropdown-menu .item-checkbox {
  vertical-align: middle;
  margin-bottom: 4px;
  margin-right: 5px;
}

.transferIndicatorDot {
  height: 10px;
  width: 10px;
  background-color: #cf0a0a;
  border-radius: 50%;
  display: inline-block;
  margin-left: 0.3rem;
}
</style>
